/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid } from '@mui/material';
import React from 'react';
import { useDrop } from 'react-dnd';

interface IProps {
  children: JSX.Element | JSX.Element[];
  title: string;
  id: string;
}

const BoxOptions: React.FC<IProps> = ( props ) => {
  const { children, title, id } = props;

  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'ITEM',
    drop: () => ({ name: title, id }),
  }));

  return (
    <Grid
      container
      justifyContent="center"
      gap={2}
      sx={{ mt: 5 }}
      ref={drop}
    >
      {children}
    </Grid>
  );
};

export default BoxOptions;
